import { inject, NgModule } from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { provideAgenticUi } from '@sasser/sfh-agentic-ui';
import { environment } from '../environments/environment';
import { ROUTES } from './app.routes';
import { AppComponent } from './app.component';
import { AgenticAuthTokenService } from './agentic/agentic-auth-token.service';
import { RAIL360_SCREEN_CATALOG } from './agentic/rail360-screen-catalog';
import { RAIL360_SUPPORTED_COMPONENTS } from './agentic/rail360-supported-components';
import { CoreModule } from './core/core.module';

import { OAuthModule } from 'angular-oauth2-oidc';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './shared/shared.module';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES),
    CoreModule,
    SharedModule,
    OAuthModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      progressBar: true
    }),
  ],
  providers: [
    provideRouter(ROUTES),
    DatePipe,
    ...provideAgenticUi({
      empowerAi: environment.empowerAi,
      screens: RAIL360_SCREEN_CATALOG,
      supportedComponents: RAIL360_SUPPORTED_COMPONENTS,
      accessToken: () => inject(AgenticAuthTokenService).token,
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
